import React, { useState, useEffect } from 'react';


export interface MyComponentProps {
  // Define your prop types here
   nodes: any
   index: string
   selectedIndices: any[]
   relatedSelectedIndices?: any
   commentAnnotationIndices?: any
   variantIndexListIndices?: any
   ftype?: string
}



export const XWords: React.FC<MyComponentProps> = ({nodes, selectedIndices, relatedSelectedIndices, commentAnnotationIndices, variantIndexListIndices, index, ftype}) => {
  const keyPrefix = ftype === "secondary" ? "sec-" : ""

  // const {counter, setCounter,incrementTotalMounted } = useCounter();
  useEffect(() => {
    // if (nodes.value && handleUpdateWordCountMap){
    //   const textCount = nodes.value.replace(/[^\w\s]|_/g, '').replace(/\s+/g, ' ').trim().split(" ").length
    //   handleUpdateWordCountMap(index, textCount)
    //}
  },[])


  const displayWords = () => {
            // return (<span> {d.value.replace(/\s+/g, " ")} </span>)
            if (nodes.value){
              let textArray = nodes.value.replace(/\s+/g, ' ').trim().split(" ").filter(word => word !== '');
              // Replace "&amp;" with "&" in textArray
              textArray = textArray.map(word => word === '&amp;' ? '&' : word);

              let punctuationSubtract: number = 0
              return textArray.map((word: string, idx2: number) => {
                // NOTE this line needs to match the characters identified as punctuation the in ngram-diff textClean function 
                if (/^[-.,:;"'¶⁋\/\\]$/.test(word)){
                  punctuationSubtract = punctuationSubtract + 1
                  return <span key={"s-" + keyPrefix + index + "-p" + idx2} data-type="punctuation">{word} </span> 
                }
                else{
                  const wordCount = idx2 - punctuationSubtract
                  const indexString = index + "-" + wordCount
                  
                  let style = {backgroundColor: "transparent", borderBottom: "none"} 

                  
                  if (commentAnnotationIndices && commentAnnotationIndices[indexString]){
                    const count = commentAnnotationIndices[indexString]
                    const clampedCount = Math.max(1, Math.min(20, count)); // Adjust the range as needed
                    // Calculate opacity based on a power function
                    const opacity = Math.pow(clampedCount / 10, .5); // Adjust the exponent as needed
                    // const opacity = 1
                    style["borderBottom"] = `3px solid rgba(0, 100, 0, ${opacity})`
                  }
                 
                  if (relatedSelectedIndices && relatedSelectedIndices[indexString]){
                    const count = relatedSelectedIndices[indexString]
                    const clampedCount = Math.max(1, Math.min(20, count)); // Adjust the range as needed
                    // Calculate opacity based on a power function
                    const opacity = Math.pow(clampedCount / 20, .5); // Adjust the exponent as needed
                    style["backgroundColor"] = `rgba(255, 95, 95, ${opacity})`
                  }
                  if (variantIndexListIndices && variantIndexListIndices[indexString]){
                    //const count = commentAnnotationIndices[indexString]
                    //const clampedCount = Math.max(1, Math.min(20, count)); // Adjust the range as needed
                    // Calculate opacity based on a power function
                    //const opacity = Math.pow(clampedCount / 20, .5); // Adjust the exponent as needed
                    const opacity = .2
                    style["backgroundColor"] = `rgba(0, 0, 255, ${opacity})`
                  }
                  if (selectedIndices?.includes(indexString)){
                    style["backgroundColor"] =  "yellow"
                  }
                  // else{
                  //   style["backgroundColor"] = "transparent"
                  // }
                  return (
                    <>
                    {(selectedIndices && selectedIndices?.includes(indexString)) ?
                    <span key={"s-" + keyPrefix + indexString} data-tooltip-id={"tooltip-" + indexString} data-index={indexString} data-last={idx2 + 1 === textArray.length ? "true" : "false"} style={style}>{word} </span>
                    :
                    <span key={"s-" + keyPrefix + indexString} data-index={indexString} data-last={idx2 + 1 === textArray.length ? "true" : "false"} style={style}>{word} </span>
                    }
                    </>
                  )
                }
              })
            }
  }
  
  return (
    displayWords()
  )
}